module.exports = __webpack_public_path__ + "img/Jimbo.a9f56223.jpeg";